<template>
    <IndexBase @auth="onAuth($event)" action="IndexAll" controller="Appraisal"></IndexBase>

    <OverlayPanel ref="op" :showCloseIcon="true" :dismissable="true"
        :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '450px' }">
        <InputText v-model="overlayText" @input="onEditRemarks" style="width:100%" />
    </OverlayPanel>

    <Dialog :header="$t('sync_confirmation')" v-model:visible="showSyncConfirmationModal" :closeOnEscape="false"
        :closable="false" :modal="true" :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '40vw' }">
        <div v-if="!processed">
            {{ this.syncAll && this.dataModelAll.length <= 0 ? this.$t('message.sync_no_data') :
        this.$t('note.sync_hcm') }} <br>
                {{ this.syncAll && this.dataModelAll.length <= 0 ? '' : this.$t('message.sync_confirmation') }} <table>
                    <tr v-for="(doc, index) in this.dataModel.filter(a => a.SelectedRow)" v-bind:key="doc.NIK"
                        v-if="!this.syncAll">
                        <td style="width: 10%;">{{ (index + 1) }}.</td>
                        <td style="width: 30%;">{{ doc.NIK }}</td>
                        <td style="width: 40%;">{{ doc.Employee_Name }}</td>
                        <td style="width: 20%;">{{ doc.Score + '% ' + doc.Rate }}</td>
                    </tr>
                    <tr v-if="this.syncAll" v-for="(doc, index) in this.dataModelAll" v-bind:key="doc.NIK">
                        <td style="width: 10%;">{{ (index + 1) }}.</td>
                        <td style="width: 30%;">{{ doc.NIK }}</td>
                        <td style="width: 40%;">{{ doc.Employee_Name }}</td>
                        <td style="width: 20%;">{{ doc.Score + '% ' + doc.Rate }}</td>
                    </tr>
                    </table>
        </div>
        <div v-else>
            <table>
                <tr v-for="(doc, index) in resultData" v-bind:key="doc.NIK">
                    <td style="width: 5%;">{{ (index + 1) }}.</td>
                    <td style="width: 15%;">{{ doc.NIK }}</td>
                    <td style="width: 30%;">{{ doc.Name }}</td>
                    <td style="width: 15%;">{{ doc.Score + '% ' + doc.Rate }}</td>
                    <td style="width: 35%;">
                        <Tag v-if="doc.Result == 'SUCCESS'" class="mr-2" :severity="'success'"
                            :value="'Sync to HCM Successfully'"></Tag>
                        <Tag v-else class="mr-2" severity="danger" :value="doc.Result"></Tag>
                    </td>
                </tr>
                <!-- <tr v-for="(doc, index) in [...new Set(resultData.filter(a => a.Result.indexOf('SUCCESS') < 0))]"
                    v-bind:key="doc.NIK" v-if="this.syncAll">
                    <td style="width: 5%;">{{ (index + 1) }}.</td>
                    <td style="width: 15%;">{{ doc.NIK }}</td>
                    <td style="width: 30%;">{{ doc.Name }}</td>
                    <td style="width: 15%;">{{ doc.Score + '% ' + doc.Rate }}</td>
                    <td style="width: 35%;">
                        <Tag class="mr-2" severity="danger" :value="doc.Result"></Tag>
                    </td>
                </tr> -->
            </table>
            <div v-if="!processing">
                <h3 style="color:green;margin:0px;">
                    {{ resultData.filter(a => a.Result.indexOf('SUCCESS') > -1).length }}
                    {{ this.$t('sap_result_success') }}
                </h3>
                <h3 style="color:red;margin:0px;">
                    {{ resultData.filter(a => a.Result.indexOf('SUCCESS') < 0).length }} {{ this.$t('sap_result_failed')
                        }} </h3>
            </div>
        </div>

        <template #footer>
            <div v-if="processed">
                <Button label="Close" @click="dismissConfirmation" />
            </div>
            <div v-else>
                <div v-if="processing">
                    <ProgressSpinner style="width:50px;height:50px" />
                    <ProgressBar :value="this.precentageProgress" v-if="this.syncAll">
                        {{ this.beginLoop }}/{{ this.dataModelAll.length }}
                    </ProgressBar>
                </div>
                <div v-else>
                    <div v-if="!processed">
                        <Button label="No" @click="dismissConfirmation" />
                        <Button label="Yes" autofocus @click="confirmSync" class="pi-button p-button-success" />
                    </div>
                    <div v-else>
                        <Button label="Close" icon="pi pi-times" class="p-button-text" @click="onClose" />
                    </div>
                </div>
            </div>
        </template>
    </Dialog>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ $t('assesed_appraisal') }}
                    </div>
                </template>
                <template #right>
                    <div class="p-card-title" style="margin-top:10px;">
                        <Button v-show="canUpload" label="Upload Komite" icon="pi pi-upload"
                            class="p-button-success p-button-sm" @click="importFile()" style="margin-left:5px;" />
                        <Button label="Sync" icon="pi pi-sync" class="p-button-warning p-button-sm"
                            @click="processSyncData()" style="margin-left:5px;"
                            v-if="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.dataModel && (this.isSelectAll || this.dataModel.filter(a => a.SelectedRow).length > 0)" />
                        <Button label="Sync All to HCM" icon="pi pi-sync" class="p-button-warning p-button-sm"
                            @click="processSyncAllData()" style="margin-left:5px;"
                            v-if="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.dataModel" />
                        <!-- <Button label="Sync All to HCM" icon="pi pi-sync" class="p-button-warning p-button-sm"
                            @click="processSyncAllData()" style="margin-left:5px;"
                            v-if="this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO && this.dataModel &&
                                this.dataModel.filter(a => a.Status_Appraisal != 'SYNC TO HCM' && a.Source == 'HCM').length > 0" />                                 -->
                    </div>
                </template>
            </Toolbar>
            <Toolbar>
                <template #left>
                    <div class="alert alert-info"><b>{{ this.$t('note.listAssed') }}</b>
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple"
                removableSort v-model:expandedRows="expandedRows" stateStorage="local" :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading" :paginator="true" :rows="10" :lazy="true"
                v-model:first="this.start"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" @rowExpand="onRowExpand"
                @state-restore="onStateRestore($event)" @state-save="onStateSave($event)" @page="onPage($event)"
                @sort="onSort($event)" @filter="onFilter($event)" @row-dblclick="onRowDoubleClick"
                v-model:filters="filters" :totalRecords="totalRecords" dataKey="Id" :metaKeySelection="false"
                :rowClass="rowClass">
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap; width: 1rem">
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter"
                            :badge="filterBadge" badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-search" v-show="canView"
                            class="p-button-rounded p-button-info mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_VIEW, dataModel.data.Log_Id)" />
                        <Button icon="pi pi-pencil"
                            v-show="canEdit && dataModel.data.K_Can_Edit && this.$store.getters.getPeriorYear == dataModel.data.Period_Year"
                            class="p-button-rounded p-button-success mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Id)" />
                        <Button icon="pi pi-list" v-show="canView"
                            class="p-button-rounded p-button-secondary mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_HISTORY, dataModel.data.Id)" />
                    </template>
                </Column>
                <Column field="SelectedRow" key="SelectedRow"
                    v-if="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin)">
                    <template #filter="{ filterModel, filterCallback }">
                        <Checkbox v-model="this.isSelectAll" @input="SelectAll()" :binary="true" />
                    </template>
                    <template #body="{ data }">
                        <div class="p-fluid">
                            <Checkbox name="SelectedRow" v-model="data.SelectedRow" :binary="true" v-if="data.Status_Appraisal != 'SYNC TO HCM' && data.Source == 'HCM' && data.Period_Year == this.$store.getters.getPeriorYear &&
        (data.S_Edit != null || data.H_Edit != null)" />
                        </div>
                    </template>
                </Column>
                <Column field="NIK" :header="$t('nik')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('nik')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Employee_Name" :header="$t('name')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('name')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Grade" :header="$t('grade')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('grade')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Superior" :header="$t('superior1')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('superior1')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Head" :header="$t('superior2')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('superior2')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Period_Year" :header="$t('period')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('period')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Score" :header="$t('total_score')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('total_score')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ data.Score }} %
                    </template>
                </Column>
                <Column field="Rate" :header="$t('rate')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Status_Appraisal" :header="$t('Status')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('Status')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Source" :header="$t('source')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('source')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Company_Name" :header="$t('company')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('company')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Unit_Name" :header="$t('unit')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('unit')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Division_Name" :header="$t('division')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('division')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Department_Name" :header="$t('department')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('department')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <!-- <Column field="Section_Name" :header="$t('section')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('section')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
                <Column field="Position_Name" :header="$t('position')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('position')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Structure" :header="$t('org_unit')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('org_unit')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Directorate_Name" :header="$t('directorate')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('directorate')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Functional_Name" :header="$t('functional')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('functional')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "Appraisal",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'appraisal-indexAll' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            lazyParamsAll: {},
            filters: null,
            stateFilters: null,
            editorPath: "/Appraisal/Editor",
            dataUrl: "appraisal/listAll",
            uploadPath: "/Helper/UploadData/Komite",
            syncUrl: "appraisal/sync_appraisal",
            listOnlySync: "appraisal/listAllOnlySync",
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            canUpload: false,
            overlayText: "",
            showSyncConfirmationModal: false,
            processed: false,
            idReset: 0,
            nameReset: null,
            processing: false,
            isSelectAll: false,
            syncAll: false,
            resultData: [],
            pageSize: 10,
            dataModelAll: null,
            limit: 0,
            beginLoop: 0,
            loopCount: 0,
            indexCount: 0,
            precentageProgress: 0,
        }
    },
    methods: {
        onEditRemarks() {
            this.overlayData.Remarks = this.overlayText;
        },
        toggleRemarksPopup(event, data) {
            this.overlayData = data;
            this.overlayText = data.Remarks;
            this.$refs.op.toggle(event);
        },
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
            this.canUpload = event.canUpload;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        dismissConfirmation() {
            this.processed = false;
            this.showSyncConfirmationModal = false;
            this.loadLazyData();
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.syncAll = false;
            this.isSelectAll = false;
            this.resultData = [];

            this.lazyParams = {
                start: this.start,
                pageSize: this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        self.dataModel = response.data.data;
                        self.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                });
        },
        setFilters(defaultPeriod) {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (defaultPeriod && exportable[i].props.field == 'Period_Year') {
                    filterValue = defaultPeriod;
                }
                else if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
            this.pageSize = event.rows;
        },
        onStateSave(event) {
            event.selectedCategoryIndex = this.selectedCategoryIndex;
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
        editor(mode, id) {
            this.$router.push({ path: this.editorPath, query: { mode: mode, id: id, answerLogId: id, fromMenu: 'AppraisalIndexAllIndex' } });
        },
        importFile() {
            this.$router.push({ path: this.uploadPath });
        },
        rowClass(data) {
            return [{ 'p-highlight': data.SelectedRow }];
        },
        SelectAll() {
            this.dataModel.filter((a, index) => a.Status_Appraisal != 'SYNC TO HCM' && a.Source == 'HCM' && (a.S_Edit != null || a.H_Edit != null) &&
                a.Period_Year == this.$store.getters.getPeriorYear && index < 101)
                .forEach((e, index) => {
                    if (this.isSelectAll)
                        e.SelectedRow = true;
                    else
                        e.SelectedRow = false;
                });
        },
        processSyncData() {
            this.showSyncConfirmationModal = true;
            this.syncAll = false;
        },
        processSyncAllData() {
            var self = this;

            this.$axios.post(this.$API_URL + this.listOnlySync)
                .then((response) => {
                    if (response.data.success) {
                        self.dataModelAll = response.data.data;
                        self.beginLoop = 0;
                        self.indexCount = 0;
                        self.loopCount = Math.ceil(this.dataModelAll.length / 100);
                        self.limit = this.dataModelAll.length > 100 ? 100 : this.dataModelAll.length;
                    }
                    else
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                })
                .finally(() => {
                    this.showSyncConfirmationModal = true;
                    this.syncAll = true;
                });
        },
        confirmSync() {
            var self = this;
            self.submitted = true;
            let listModel = [];

            if (self.syncAll) {
                if (self.loopCount != 0 && self.limit != 0) {
                    for (let j = self.beginLoop; j < self.limit; j++) {
                        var empData = self.dataModelAll[j];

                        var data =
                        {
                            Id: empData.Id,
                            NIK: empData.NIK,
                            Name: empData.Employee_Name,
                            NIK_Approval1: empData.NIK_Approval1,
                            Name_Approval1: empData.Superior,
                            NIK_Approval2: empData.NIK_Approval2,
                            Name_Approval2: empData.Head,
                            Score: empData.Score,
                            Rate: empData.Rate,
                            Result: ''
                        };

                        listModel.push(data);
                    }

                    self.processing = true;

                    this.$axios.put(this.$API_URL + this.syncUrl, listModel)
                        .then((response) => {
                            if (response.data.success) {
                                if (self.beginLoop == 0)
                                    self.resultData = response.data.data;
                                else
                                    self.resultData = [].concat(self.resultData, response.data.data);

                                self.precentageProgress = self.limit / self.dataModelAll.length * 100;
                            }
                            else {
                                self.loopCount = 0;
                                self.limit = 0;
                                self.$toast.add({ severity: 'error', summary: "Data Failed to Send", detail: response.data.message, life: 5000 });
                            }
                        })
                        .catch(function (error) {
                            self.loopCount = 0;
                            self.limit = 0;
                            self.processed = false;
                            self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
                        })
                        .finally(() => {
                            self.beginLoop = self.limit;
                            self.indexCount++;

                            if (self.indexCount == self.loopCount) {
                                self.loopCount = 0;
                                self.limit = 0;
                                self.processed = true;
                                self.processing = false;
                                self.$toast.add({ severity: 'success', summary: 'Data Sent', detail: "Appraisal data successfully sent to SAP HCM", life: 5000 });
                            }
                            else {
                                self.limit += self.limit;

                                if (self.limit > self.dataModelAll.length)
                                    self.limit = self.dataModelAll.length;

                                self.confirmSync();
                            }
                        });
                }
            }
            else {
                self.processing = true;

                var selectedData = self.dataModel.filter(a => a.SelectedRow);
                for (let j = 0; j < selectedData.length; j++) {
                    var empData = selectedData[j];

                    var data =
                    {
                        Id: empData.Id,
                        NIK: empData.NIK,
                        Name: empData.Employee_Name,
                        NIK_Approval1: empData.NIK_Approval1,
                        Name_Approval1: empData.Superior,
                        NIK_Approval2: empData.NIK_Approval2,
                        Name_Approval2: empData.Head,
                        Score: empData.Score,
                        Rate: empData.Rate,
                        Result: ''
                    };

                    listModel.push(data);
                }

                this.$axios.put(this.$API_URL + this.syncUrl, listModel)
                    .then((response) => {
                        self.processed = true;
                        self.resultData = response.data.data;

                        if (response.data.success)
                            self.$toast.add({ severity: 'success', summary: 'Data Sent', detail: "Appraisal data successfully sent to SAP HCM", life: 5000 });
                        else
                            self.$toast.add({ severity: 'error', summary: "Data Failed to Send", detail: response.data.message, life: 5000 });
                    })
                    .catch(function (error) {
                        self.processed = false;
                        self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
                    })
                    .finally(() => {
                        self.processing = false;
                    });
            }
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters(this.$store.getters.getPeriorYear);
        this.loadLazyData();
        this.$showToast();
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        },
    },
}
</script>

<style scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}

.alert-info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
}

.alert {
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>